import { booleanAttribute, ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';

import { AdminModeService } from '../../../auth/admin-mode/admin-mode.service';
import { AuthorizationWrapper } from '../../authorization/authorization.wrapper';
import { HeaderContainer } from '../../header/components/header.container';
import { trackInput } from '../../utils/signal/trackInput';
import { OpenCustomerEvent } from '../../web-component/event.model';
import { WebComponentDirective } from '../../web-component/web-component.directive';
import { CustomerSearchWrapper } from './customer-search.wrapper';

@Component({
  selector: 'cdf-customer-search-web-component',
  imports: [AuthorizationWrapper, HeaderContainer, CustomerSearchWrapper],
  template: `
    @if (showHeader()) {
      <cdf-header />
    }

    <cdf-authorization-wrapper>
      <cdf-customer-search
        [hideVinSearch]="hideVinSearch()"
        [hideLicenseSearch]="hideLicenseSearch()"
        (openCustomerProfile)="openCustomerProfile.emit({ type: 'OPEN_CUSTOMER', accountNumber: $event.accountNumber })"
      />
    </cdf-authorization-wrapper>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerSearchWebComponent extends WebComponentDirective {
  readonly hideVinSearch = input(false, { transform: booleanAttribute });
  readonly hideLicenseSearch = input(false, { transform: booleanAttribute });

  readonly openCustomerProfile = output<OpenCustomerEvent>();

  private readonly adminModeService = inject(AdminModeService);

  readonly showHeader = input(false, { transform: booleanAttribute });
  protected readonly propagateShowHeader = trackInput(this.showHeader, this.adminModeService.adminModeReachable);
}
